import { SecurityOr } from 'tm3-core/controls/security/secure';
export default SecurityOr;
